import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import {
	getReactionsQueryInfo,
	type ReactionsQueryVariablesType,
	type ReactionsQueryDataType,
} from './utils/data.ts';

export function preloadPageReactions({ pageId, containerId }) {
	const { query: reactionsQuery, queryVariables } = getReactionsQueryInfo(
		false,
		pageId,
		containerId,
	);

	return query<ReactionsQueryDataType, ReactionsQueryVariablesType>({
		query: reactionsQuery,
		variables: queryVariables,
	});
}
